// Product / asset behaviors: asset-manager lightbox and PDP form-product mode.

var LIGHTBOX_ITEM_SELECTOR = '.zd-filter-item[data-large-url]';

var current_lightbox_item = null;
var lightbox_last_closed_at = 0;

// === navigation helpers ===

function get_lightbox_navigable_items() {
    var $visible_items = jQuery(LIGHTBOX_ITEM_SELECTOR + ':visible');
    return $visible_items.length ? $visible_items : jQuery(LIGHTBOX_ITEM_SELECTOR);
}

function update_lightbox_nav_buttons() {
    var $items = get_lightbox_navigable_items();
    var current_index = current_lightbox_item ? $items.index(current_lightbox_item) : -1;
    var has_prev = current_index > 0;
    var has_next = current_index >= 0 && current_index < ($items.length - 1);

    jQuery('.zd-lightbox-prev').prop('disabled', !has_prev);
    jQuery('.zd-lightbox-next').prop('disabled', !has_next);
}

// === media aspect ratio classes ===

function clear_lightbox_media_ratio_state() {
    jQuery('.zd-lightbox-content').removeClass(
        'zd-lightbox-media-portrait zd-lightbox-media-landscape zd-lightbox-media-square'
    );
}

function apply_lightbox_media_ratio_state($img) {
    if (!$img || !$img.length) {
        clear_lightbox_media_ratio_state();
        return;
    }

    var img = $img.get(0);
    if (!img || !img.naturalWidth || !img.naturalHeight) {
        clear_lightbox_media_ratio_state();
        return;
    }

    var ratio = img.naturalWidth / img.naturalHeight;
    clear_lightbox_media_ratio_state();

    if (ratio > 1.1) {
        jQuery('.zd-lightbox-content').addClass('zd-lightbox-media-landscape');
    } else if (ratio < 0.9) {
        jQuery('.zd-lightbox-content').addClass('zd-lightbox-media-portrait');
    } else {
        jQuery('.zd-lightbox-content').addClass('zd-lightbox-media-square');
    }
}

// === linked products payload ===

function normalize_linked_products(raw) {
    if (Array.isArray(raw)) return raw;
    if (!raw && raw !== 0) return [];

    if (typeof raw === 'string') {
        var trimmed = raw.trim();
        if (!trimmed) return [];

        try {
            var parsed = JSON.parse(trimmed);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e1) {
            try {
                var decoded = jQuery('<textarea/>').html(trimmed).text();
                var parsed_decoded = JSON.parse(decoded);
                return Array.isArray(parsed_decoded) ? parsed_decoded : [];
            } catch (e2) {
                return [];
            }
        }
    }

    return [];
}

// === open / navigate / close ===

function reset_lightbox_image_styles($img) {
    if (!$img || !$img.length) {
        return;
    }

    $img
        .removeClass('zd-product-gallery__image wp-post-image')
        .css({
            width: '',
            height: '',
            maxWidth: '',
            maxHeight: '',
            objectFit: '',
        });
}

function open_asset_lightbox($item) {
    if (!$item || !$item.length) return;

    current_lightbox_item = $item.first();
    jQuery('.zd-lightbox-overlay').removeAttr('data-zds-gallery-lightbox');

    var videoLink = String($item.data('video-link') || '');
    var embedHtml = '';

    if (videoLink.length > 0) {
        if (videoLink.includes('youtube.com') || videoLink.includes('youtu.be')) {
            var youtubeId = '';
            if (videoLink.includes('youtu.be/')) {
                youtubeId = videoLink.split('youtu.be/')[1].split(/[?&]/)[0];
            } else {
                var youtubeMatch = videoLink.match(/v=([^&]+)/);
                youtubeId = youtubeMatch ? youtubeMatch[1] : '';
            }
            if (youtubeId) {
                embedHtml =
                    '<iframe class="zd-lightbox-video-frame" src="https://www.youtube.com/embed/' +
                    youtubeId + '?autoplay=1" frameborder="0" allowfullscreen></iframe>';
            }
        } else if (videoLink.includes('vimeo.com')) {
            var vimeoId = videoLink.split('vimeo.com/')[1].split(/[?&]/)[0];
            if (vimeoId) {
                embedHtml =
                    '<iframe class="zd-lightbox-video-frame" src="https://player.vimeo.com/video/' +
                    vimeoId + '?autoplay=1" frameborder="0" allowfullscreen></iframe>';
            }
        }
    }

    if (embedHtml) {
        clear_lightbox_media_ratio_state();
        jQuery('#zd-lightbox-img').hide().attr('src', '');
        jQuery('#zd-lightbox-video').html(embedHtml);
    } else {
        jQuery('#zd-lightbox-video').html('');
        var largeUrl = $item.data('large-url');
        if (largeUrl) {
            var $lightboxImage = jQuery('#zd-lightbox-img');
            reset_lightbox_image_styles($lightboxImage);
            $lightboxImage
                .off('load.zdLightboxRatio')
                .one('load.zdLightboxRatio', function() {
                    apply_lightbox_media_ratio_state(jQuery(this));
                })
                .attr('src', largeUrl)
                .show();

            if ($lightboxImage.get(0) && $lightboxImage.get(0).complete) {
                apply_lightbox_media_ratio_state($lightboxImage);
            }
        } else {
            clear_lightbox_media_ratio_state();
            jQuery('#zd-lightbox-img').hide().attr('src', '');
        }
    }

    var html = '';
    var description = String($item.data('description') || '');
    if (description.length > 0) {
        html += '<div style="margin-bottom:10px;">' + description + '</div>';
    }

    var productsData = normalize_linked_products($item.data('linked-products'));
    if (Array.isArray(productsData) && productsData.length > 0) {
        var related_products_string = productsData.length === 1 ? 'Product:' : 'Products:';
        html += '<ul style="list-style:none; padding:0; margin:0;">' +
            '<li style="display: inline-block; margin-right: 10px; font-weight: bold;">' +
            related_products_string + '</li>';
        productsData.forEach(function(itemData) {
            if (itemData.title && itemData.url) {
                html +=
                    '<li style="display: inline-block; margin-right: 20px;"><a href="' +
                    itemData.url +
                    '" target="_blank" style="color:#fff; text-decoration:underline;">' +
                    itemData.title + '</a></li>';
            }
        });
        html += '</ul>';
    }

    jQuery('#zd-lightbox-products').html(html).show();
    update_lightbox_nav_buttons();

    if (!jQuery('.zd-lightbox-overlay').is(':visible')) {
        jQuery('.zd-lightbox-overlay').fadeIn(150);
    }
}

function navigate_asset_lightbox(direction) {
    var $items = get_lightbox_navigable_items();
    if (!$items.length) return;

    var current_index = current_lightbox_item ? $items.index(current_lightbox_item) : -1;
    if (current_index < 0) current_index = 0;

    var next_index = current_index + direction;
    if (next_index < 0 || next_index >= $items.length) return;

    open_asset_lightbox(jQuery($items.get(next_index)));
}

function close_asset_lightbox() {
    lightbox_last_closed_at = Date.now();
    jQuery('.zd-lightbox-overlay').removeAttr('data-zds-gallery-lightbox').fadeOut(150);
    jQuery('#zd-lightbox-img').hide().attr('src', '');
    jQuery('#zd-lightbox-video').empty();
    jQuery('#zd-lightbox-products').hide().empty();
    clear_lightbox_media_ratio_state();
    current_lightbox_item = null;
}

// === event bindings ===

function init_asset_lightbox() {
    jQuery(document).on('click', LIGHTBOX_ITEM_SELECTOR, function() {
        // Prevent immediate reopen when closing by clicking backdrop.
        if (Date.now() - lightbox_last_closed_at < 250) return;
        open_asset_lightbox(jQuery(this));
    });

    function is_gallery_lightbox_open() {
        return jQuery('.zd-lightbox-overlay').attr('data-zds-gallery-lightbox') === '1';
    }

    jQuery(document).on('click', '.zd-lightbox-prev', function(e) {
        if (is_gallery_lightbox_open()) return;
        e.preventDefault();
        e.stopPropagation();
        navigate_asset_lightbox(-1);
    });

    jQuery(document).on('click', '.zd-lightbox-next', function(e) {
        if (is_gallery_lightbox_open()) return;
        e.preventDefault();
        e.stopPropagation();
        navigate_asset_lightbox(1);
    });

    jQuery(document).on('click', '.zd-lightbox-close', function(e) {
        if (is_gallery_lightbox_open()) return;
        e.preventDefault();
        e.stopPropagation();
        close_asset_lightbox();
    });

    jQuery(document).on('click', '.zd-lightbox-overlay, .zd-lightbox-overlay .flex-container', function(e) {
        if (is_gallery_lightbox_open()) return;

        var $target = jQuery(e.target);
        var clicked_inside_content = $target.closest('.zd-lightbox-content').length > 0;
        var clicked_interactive_content = $target.closest(
            '.zd-lightbox-close, .zd-lightbox-nav, #zd-lightbox-img, #zd-lightbox-video, #zd-lightbox-products, #zd-lightbox-products a, .zd-lightbox-content iframe'
        ).length > 0;

        if (clicked_inside_content && clicked_interactive_content) return;

        e.preventDefault();
        e.stopPropagation();
        close_asset_lightbox();
    });

    jQuery(document).on('keydown', function(e) {
        if (!jQuery('.zd-lightbox-overlay').is(':visible')) return;
        if (is_gallery_lightbox_open()) return;

        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            navigate_asset_lightbox(-1);
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            navigate_asset_lightbox(1);
        } else if (e.key === 'Escape') {
            close_asset_lightbox();
        }
    });
}

// === single-product "form product" mode ===
// Some variations are configured as "form products" (request-a-quote style):
// when found_variation fires with zd_is_form_product, swap the add-to-cart UI
// for the form HTML supplied with the variation.

function set_form_product_mode(form_el, is_form, form_html, variation_id, is_description_mode) {
    var form = jQuery(form_el);

    var wrap_form = form.find('.zd_form_product_wrap');
    var wrap_cart = form.find('.single_variation_wrap');
    var wrap_qty = form.find('.zd-variation__amount');
    var html_target = form.find('[data_zd_form_product_html]');
    var toggle_wrap = wrap_form.find('[data-bs-toggle="collapse"]').closest('p');

    if (is_form) {
        wrap_cart.hide();
        wrap_qty.hide();
        wrap_form.show();

        if (html_target.length) {
            html_target.html(form_html || '');
        }

        wrap_form.find('[data-variation]').attr('data-variation', String(variation_id || 0));

        var collapse_el = form.find('#zd_form_product_collapse');
        if (is_description_mode) {
            toggle_wrap.hide();
            if (collapse_el.length) {
                collapse_el.addClass('show');
            }
        } else {
            toggle_wrap.show();
            if (collapse_el.length && collapse_el.hasClass('show')) {
                collapse_el.removeClass('show');
            }
        }

        return;
    }

    wrap_form.hide();
    wrap_cart.show();
    wrap_qty.show();
    toggle_wrap.show();

    if (html_target.length) html_target.empty();

    wrap_form.find('[data-variation]').attr('data-variation', '0');
}

function init_read_full_description() {
    jQuery(document).on('click', '.zd-read-more[href="#full-description"]', function() {
        var button = document.querySelector('#heading_description .accordion-button');
        if (button && button.classList.contains('collapsed')) {
            button.click();
        }
    });
}

function init_form_product_mode() {
    jQuery(document).on('found_variation', 'form.variations_form', function(e, variation) {
        var is_form = !!(variation && (
            variation.zd_is_form_product === 1 ||
            variation.zd_is_form_product === '1' ||
            variation.zd_is_form_product === true
        ));

        var is_description_mode = !!(variation && (
            variation.zd_is_included_template_description === 1 ||
            variation.zd_is_included_template_description === '1' ||
            variation.zd_is_included_template_description === true
        ));

        var form_html = variation && variation.zd_form_html ? String(variation.zd_form_html) : '';
        var variation_id = variation && variation.variation_id ? parseInt(variation.variation_id, 10) : 0;

        set_form_product_mode(this, is_form, form_html, variation_id, is_description_mode);
    });
}

export function init() {
    init_asset_lightbox();
    init_read_full_description();
    init_form_product_mode();
}
